export const META_KEYS = {
  canEnterInOfflineMode: 'canEnterInOfflineMode',
} as const;

export type MetaKey = keyof typeof META_KEYS;

export type OfflineDatabaseMeta = { key: MetaKey; value: boolean };
